// @ts-nocheck
import React, {useEffect, useState} from 'react';
import Table from "./Table/Table";
import {Naskor} from "../../../../js/components/naskor";
import LoadingSpinner from '../../../Abstracts/LoadingSpinner/LoadingSpinner';
import { getRequest } from '../../../Helper/ApiClient';
import { useUser } from '../../../Context/UserContext';

require('./RemainingBasket.scss');

export default function RemainingBasket(props) {
  const basketRequest = getRequest('/api/onlineshop/remaining_basket');
    const [errorPerFlavour, setErrorPerFlavour] = useState([]);
    const [qtyPerFlavour, setQtyPerFlavour] = useState([]);
    const [placeOrderError, setPlaceOrderError] = useState();
    const [orderPriceSum, setOrderPriceSum] = useState(0);
    const [orderPlacingInProgress, setOrderPlacingInProgress] = useState(false);
    const { user } = useUser();
    const allowUpload = !!(user && user.allow_upload_release_basket_qty);

    const handleChange = (product_attribute_id, remaining_qty, value) => {
		// setRemaining(value.replace(/\+|-|0/ig, ''));
		let errorPerFlavour_tmp = JSON.parse(JSON.stringify(errorPerFlavour));
		errorPerFlavour_tmp[product_attribute_id] = false;
		setErrorPerFlavour(errorPerFlavour_tmp);

		let qtyPerFlavour_tmp = JSON.parse(JSON.stringify(qtyPerFlavour));
		qtyPerFlavour_tmp[product_attribute_id] = value;
		setQtyPerFlavour(qtyPerFlavour_tmp);
		setOrderPriceSum(getNextOrderPriceSum(qtyPerFlavour_tmp));

		if(value > remaining_qty) {
			errorPerFlavour_tmp = JSON.parse(JSON.stringify(errorPerFlavour_tmp));
			errorPerFlavour_tmp[product_attribute_id] = 'Max remaining: ' + remaining_qty;
			setErrorPerFlavour(errorPerFlavour_tmp);
		} else {
			Naskor.fetchJson('/api/onlineshop/check_flavour_stock/' + product_attribute_id)
				.then((response) => {
					if(response.success === true) {
						if(response.stock < value) {
							errorPerFlavour_tmp = JSON.parse(JSON.stringify(errorPerFlavour_tmp));
							errorPerFlavour_tmp[product_attribute_id] = 'Max stock: ' + response.stock;
							setErrorPerFlavour(errorPerFlavour_tmp);
						}
					}
				});
		}
    };

    const handleSubmit = (form) => {
		let formData = new FormData(form);
		setPlaceOrderError(null);
		setOrderPlacingInProgress(true);
		formData.forEach((value, key) => {
			if (value === '') {
				formData.delete(key);
			}
		});
		Naskor.fetchJson('/api/onlineshop/place_partial_order', formData)
			.then((response) => {
				if(response.success === true) {
					if(props.defineView) {
						props.defineView();
					} else {
						setOrderPlacingInProgress(false);
					}
				} else {
					setPlaceOrderError(response.error);
					setOrderPlacingInProgress(false);
				}
			});
	};

	const applyUploadedQuantities = (quantities) => {
		const positions = (basketRequest.data && basketRequest.data.positions) ? basketRequest.data.positions : [];
		let qtyPerFlavour_tmp = JSON.parse(JSON.stringify(qtyPerFlavour));
		let errorPerFlavour_tmp = JSON.parse(JSON.stringify(errorPerFlavour));
		positions.forEach(function (position) {
			const id = position.product_attribute_id;
			if (position.product_attribute_stock_count <= 0) {
				return; // out of stock: Row renders no input (shows ETA), so do not set a next-order qty
			}
			if (quantities[id] === undefined) {
				return;
			}
			const value = quantities[id];
			qtyPerFlavour_tmp[id] = value;
			errorPerFlavour_tmp[id] = false;
			if (value > position.remaining_qty) {
				errorPerFlavour_tmp[id] = 'Max remaining: ' + position.remaining_qty;
			} else if (value > position.product_attribute_stock_count) {
				errorPerFlavour_tmp[id] = 'Max stock: ' + position.product_attribute_stock_count;
			}
		});
		setQtyPerFlavour(qtyPerFlavour_tmp);
		setErrorPerFlavour(errorPerFlavour_tmp);
		setOrderPriceSum(getNextOrderPriceSum(qtyPerFlavour_tmp));
	};

	const handleFileUpload = (file) => {
		setPlaceOrderError(null);
		let formData = new FormData();
		formData.append('file', file);
		Naskor.fetchJson('/api/onlineshop/remaining_basket/upload-release-quantities', formData)
			.then((response) => {
				if (response.success === true) {
					applyUploadedQuantities(response.quantities || {});
				} else {
					setPlaceOrderError(response.error || 'Upload failed.');
				}
			});
	};

    const getNextOrderPriceSum = (qtyPerFlavour) => {
    	let sumQty = 0;
		if(
			basketRequest.data
			&& basketRequest.data.positions
			&& basketRequest.data.positions.length > 0
		) {
			basketRequest.data.positions.map(function (position) {
				let qty = parseInt(qtyPerFlavour[position.product_attribute_id]);
				qty = (Number.isInteger(qty) && qty > 0) ? qty : 0;
				sumQty += qty * position.vts_price;
			});
		}
		return sumQty;

	};

    if(orderPlacingInProgress || !basketRequest.data) {
    	return <LoadingSpinner />;
	}

    const hasOneOfPositionsStock = () => {
		if(basketRequest.data.positions && basketRequest.data.positions.length > 0) {
			for (let i = 0; i < basketRequest.data.positions.length; i++) {
				if(basketRequest.data.positions[i].product_attribute_stock_count > 0) {
					return true
				}
			}
		}
		return false;
	};

    return (
      <div className="orderRelease">
        <form
          id="orderRelease_form"
          onSubmit={(event) => {
            event.preventDefault();
            handleSubmit(event.currentTarget);
          }}
        >
          <Table
            basketData={basketRequest.data}
            handleChange={handleChange}
            errorPerFlavour={errorPerFlavour}
            qtyPerFlavour={qtyPerFlavour}
            allowUpload={allowUpload}
            handleFileUpload={handleFileUpload}
          />
          {placeOrderError && (
            <div className="row">
              <div className="col-sm-12 text-end placeOrderError">
                {placeOrderError}
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-sm-12 text-end orderPriceSum">
              {Naskor.formatPrice(orderPriceSum)}
            </div>
          </div>
          <div className="row place-order pb-5">
            <div
              className="col-sm-12 text-end"
              title={
                orderPriceSum <= 0
                  ? hasOneOfPositionsStock()
                    ? 'Please insert the quantities you want to release.'
                    : 'Unfortunately non of items above are available. Please check back soon.'
                  : ''
              }
            >
              <input
                type="submit"
                className={
                  'btn btn-primary' + (orderPriceSum <= 0 ? ' disabled' : '')
                }
                value="Release order"
                disabled={orderPriceSum <= 0}
              />
            </div>
          </div>
        </form>
      </div>
    );

}